var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedWarningCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C6.49 2.5 2 6.99 2 12.5C2 18.01 6.49 22.5 12 22.5C17.51 22.5 22 18.01 22 12.5C22 6.99 17.51 2.5 12 2.5ZM11.25 8.5C11.25 8.09 11.59 7.75 12 7.75C12.41 7.75 12.75 8.09 12.75 8.5V13.5C12.75 13.91 12.41 14.25 12 14.25C11.59 14.25 11.25 13.91 11.25 13.5V8.5ZM12.92 16.88C12.87 17.01 12.8 17.11 12.71 17.21C12.61 17.3 12.5 17.37 12.38 17.42C12.26 17.47 12.13 17.5 12 17.5C11.87 17.5 11.74 17.47 11.62 17.42C11.5 17.37 11.39 17.3 11.29 17.21C11.2 17.11 11.13 17.01 11.08 16.88C11.03 16.76 11 16.63 11 16.5C11 16.37 11.03 16.24 11.08 16.12C11.13 16 11.2 15.89 11.29 15.79C11.39 15.7 11.5 15.63 11.62 15.58C11.86 15.48 12.14 15.48 12.38 15.58C12.5 15.63 12.61 15.7 12.71 15.79C12.8 15.89 12.87 16 12.92 16.12C12.97 16.24 13 16.37 13 16.5C13 16.63 12.97 16.76 12.92 16.88Z",
    fill: "#ED6767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWarningCircle);
export default __webpack_public_path__ + "static/media/red-warning-circle.e57ba0358868bd55cb64655054b35c44.svg";
export { ForwardRef as ReactComponent };